import type { Parceiro } from "./tipos"

// Zorya (usezorya.ai, antiga QRPoint), ecossistema de DP que leva o consignado aos clientes dela.
// Cores e fonte tiradas do app deles e do logo oficial: o roxo quase preto nas superfícies e o
// lavanda no fundo dos destaques. O neutro dos gráficos é um violeta médio — o roxo da marca ao lado
// do cinza de "perdemos" quase some numa fatia fina.
export const ZORYA: Parceiro = {
    slug: "zorya",
    nome: "Zorya",
    doParceiro: "da Zorya",
    comArtigo: "a Zorya",
    tituloDaAba: "Zorya · Portal do Empregador",
    // O "z" do logo oficial sobre o roxo da marca, como o ícone do app deles.
    favicon: "/brand/zorya-favicon.svg",
    // O arquivo oficial do logo, numa cor só. A versão escura é a mesma arte na
    // tinta do tema escuro.
    marca: {
        tipo: "imagem",
        claro: "/brand/zorya.svg",
        escuro: "/brand/zorya-branco.svg",
        alt: "Zorya",
    },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#292044",
            "brand-ink": "#ffffff",
            "brand-strong": "#1c1630",
            "brand-wash": "#f3ecff",
            data: "#6e4fc4",
            page: "#faf8fd",
            card: "#ffffff",
            sunk: "#f1ebfb",
            ink: "#292044",
            soft: "#3a3350",
            faint: "#6b6580",
            line: "#e7e1f0",
            "line-strong": "#cdc4dd",
        },
        escuro: {
            brand: "#c9b3ff",
            "brand-ink": "#17121f",
            "brand-strong": "#ddd0ff",
            "brand-wash": "#2e2448",
            data: "#a58cf0",
            page: "#110d18",
            card: "#1a1524",
            sunk: "#241d31",
            ink: "#f3effa",
            soft: "#e0daea",
            faint: "#b3abc2",
            line: "#2d2639",
            "line-strong": "#463d55",
        },
    },
    fontes: {
        titulo: '"Inter Variable", ui-sans-serif, system-ui, sans-serif',
        texto: '"Inter Variable", ui-sans-serif, system-ui, sans-serif',
        numeros: '"Inter Variable", ui-sans-serif, system-ui, sans-serif',
        carregar: () => import("@fontsource-variable/inter"),
    },
}
